<template>
  <div class="image-upload__list">
    <div
      class="image-upload__toggle-button-panel"
      v-if="images && images.length > 1"
    >
      <button
        class="button image-upload__toggle-button image-upload__toggle-button--draggable-on"
        :class="{
          'button--invert': !isDraggable,
          'button--disabled': isDraggable,
        }"
        @click="setDraggable($event, true)"
      >
        Ændre rækkefølge
      </button>
      <button
        class="button image-upload__toggle-button image-upload__toggle-button--draggable-off"
        :class="{
          'button--invert': isDraggable,
          'button--disabled': !isDraggable,
        }"
        @click="setDraggable($event, false)"
      >
        Ok
      </button>
    </div>
    <div class="image-upload__item-container">
      <draggable
        v-model="images"
        item-key="filenameGuid"
        :animation="200"
        handle=".image-upload__item--draggable"
        @end="onEnd"
        :tag="'span'"
      >
        <template #item="{ element, index }">
          <div
            class="image-upload__item"
            :class="{ 'image-upload__item--draggable': isDraggable }"
          >
            <div class="image-upload__image-container">
              <img
                loading="lazy"
                class="image-upload__image"
                :src="element.url"
                alt
              />
              <div
                class="image-upload__mobile-draggable-border"
                v-if="isDraggable === true"
              ></div>
              <div class="image-upload__control">
                <button class="image-upload__button">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" v-bind:loading="'lazy'" v-bind:class="'image-upload__icon'" v-bind:svg-inline="''" @click="imageDelete(index, element)" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="none" fill-rule="evenodd"><circle cx="15" cy="15" r="15" fill="#FFF" fill-opacity=".68"/><path d="M5.43 7.08h18.6V8H5.43z"/><path fill="#333" d="M22.32 9.02H7.24a.38.38 0 110-.78l15.08.01a.38.38 0 110 .77"/><path fill="#333" d="M19.16 24.2h-8.8c-1.23 0-2.23-1-2.23-2.23V8.64h.77v13.33c0 .81.66 1.47 1.46 1.47h8.8c.81 0 1.47-.66 1.47-1.47V8.64h.77v13.33c0 1.24-1 2.24-2.23 2.24"/><path fill="#333" d="M11.94 20.24a.39.39 0 01-.38-.39V12.8c0-.21.17-.38.38-.38s.39.17.39.38v7.06c0 .22-.18.39-.39.39m2.78.73a.39.39 0 01-.38-.39v-8.52a.38.38 0 11.76 0v8.52c0 .22-.17.39-.38.39m2.96-.73a.39.39 0 01-.38-.39V12.8c0-.21.17-.38.38-.38.22 0 .39.17.39.38v7.06c0 .22-.17.39-.39.39"/><path d="M10.94 3.61h7.64v3.93h-7.64z"/><path fill="#333" d="M18.07 8.64h-.77V6.6a.54.54 0 00-.54-.54h-3.9c-.25 0-.53.2-.53.54v2.04h-.78V6.6c0-.81.69-1.31 1.32-1.31h3.89c.63 0 1.3.5 1.3 1.3v2.05z"/></g></svg>
                </button>
                <button class="image-upload__button">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" v-bind:loading="'lazy'" v-bind:class="'image-upload__icon'" v-bind:svg-inline="''" @click="imageRotate(index, element)" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="none" fill-rule="evenodd"><circle cx="15" cy="14.88" r="15" fill="#FFF" fill-opacity=".68"/><path fill="#333" stroke="#333" stroke-width=".1" d="M22.33 21a.31.31 0 01-.25-.26l-.42-2.94-2.94 1.27a.31.31 0 11-.25-.58l3.32-1.42c.09-.04.2-.03.28.01.08.05.14.14.15.23l.48 3.34c.02.17-.1.33-.27.35h-.1M7.9 12.51a.3.3 0 01-.23-.24l-.56-3.16a.3.3 0 01.24-.35.3.3 0 01.35.24l.5 2.79 2.76-1.3c.2-.12.45.03.44.26a.3.3 0 01-.19.27L8.1 12.5a.28.28 0 01-.18.02"/><path fill="#333" stroke="#333" stroke-width=".2" d="M15.01 22.22c-1.9 0-3.7-.7-5.12-1.98a7.56 7.56 0 01-2.48-5.28.22.22 0 01.22-.23.22.22 0 01.23.21 7.12 7.12 0 002.33 4.97 7.12 7.12 0 005.16 1.86 7.19 7.19 0 006.34-4.52.22.22 0 01.28-.13c.12.05.17.18.13.3a7.63 7.63 0 01-7.09 4.8m7.4-7.21h0a.22.22 0 01-.22-.23 6.93 6.93 0 00-.01-.5 7.18 7.18 0 00-7.49-6.83 7.12 7.12 0 00-4.02 1.46 7.16 7.16 0 00-2.44 3.39.22.22 0 01-.28.13.22.22 0 01-.14-.28 7.6 7.6 0 012.6-3.6 7.54 7.54 0 014.26-1.54 7.62 7.62 0 017.96 7.78.22.22 0 01-.22.22"/></g></svg>
                </button>
              </div>
              <span class="image-upload__text">{{ index + 1 }}</span>
            </div>
          </div>
        </template>
      </draggable>
      <div
        class="image-upload__item image-upload__item--dropform image-upload__item--no-cursor"
      >
        <form
          class="image-upload__upload-container"
          ref="dropform"
          method="post"
          action
          enctype="multipart/form-data"
        >
          <div class="spinner__loader-container" v-if="isUploading">
            <div class="spinner--loader"></div>
          </div>
          <input
            id="file"
            class="image-upload__upload"
            type="file"
            accept=".jpg,.jpeg"
            multiple
            @change="uploadChange"
          />
          <label for="file" class="image-upload__upload-label">
            <span class="image-upload__upload-button">
              <span class="image-upload__upload-image"></span>
              <span class="image-upload__upload-arrow-container">
                <span class="image-upload__upload-arrow"></span>
              </span>
            </span>
          </label>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { debounce } from '@/functions'

export default {
  components: {
    draggable,
  },
  props: {
    eventBus: { default: null, type: Object },
    imageList: {
      default: () => {
        return []
      },
      type: Array,
    },
  },
  data() {
    return {
      images: this.imageList,
      imageTotalCount: 0,
      isUploading: false,
      isDraggable: false,
      lastWindowWidth: 0,
      autoDraggableThreshold: 640,
    }
  },
  methods: {
    onEnd(event) {
      this.moveImage(event.newIndex)
    },
    moveImage(index) {
      // Overstiges index, lægges det draggede billedet til sidst
      if (index > this.images.length - 1) {
        index = this.images.length - 1
      }

      this.eventBus.emit('image-moved-callback', {
        guid: this.images[index].filenameGuid,
        order: index + 1,
      })
    },
    imageRotate(index, item) {
      this.eventBus.emit('image-rotated-callback', item)
    },
    imageDelete(index, item) {
      this.eventBus.emit('image-deleted-callback', item)
    },
    uploadChange(elm) {
      if (elm.target.files && elm.target.files[0]) {
        this.isUploading = true
        this.eventBus.emit('set-lock')
        const owner = this
        const files = elm.target.files
        this.imageTotalCount = this.images.length + files.length

        files.forEach(file => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = e => {
            if (e.target) {
              owner.eventBus.emit(
                'image-uploaded-callback',
                reader.result.split(',')[1] // remove header from base64
              )
            }
          }
        })
      }
    },
    resetUploadImage() {
      this.isUploading = false
    },
    imagesUpdated(imageArray) {
      this.images = imageArray

      if (imageArray.length === this.imageTotalCount) {
        this.$nextTick(() => {
          this.isUploading = false
          this.eventBus.emit('release-lock')
        })
      }
    },
    handleResizeListener() {
      this.handleResize(this)
    },
    handleResize: debounce(owner => {
      if (window.innerWidth >= owner.autoDraggableThreshold) {
        owner.isDraggable = true
      } else if (
        window.innerWidth < owner.autoDraggableThreshold &&
        owner.autoDraggableThreshold < owner.lastWindowWidth
      ) {
        owner.isDraggable = false
      }
      owner.setLastWindowWidth()
    }, 100),
    setLastWindowWidth() {
      this.lastWindowWidth = window.innerWidth
    },
    setDraggable(event, isDraggable) {
      this.isDraggable = isDraggable

      if (!event.currentTarget) return
      event.currentTarget.blur()
    },
  },
  created() {
    if (!this.eventBus) {
      return false
    }
    this.setLastWindowWidth()
    this.handleResize(this)
    this.eventBus.on('images-updated', this.imagesUpdated)
    this.eventBus.on('reset-image-upload', this.resetUploadImage)
    window.addEventListener('resize', this.handleResizeListener)
  },
  unmounted() {
    window.removeEventListener('resize', this.handleResizeListener)
  },
}
</script>

<style lang="scss">
@import 'ImageUpload.scss';
</style>
